import { render, staticRenderFns } from "./orderModeDeductionLists.vue?vue&type=template&id=0b538d82&scoped=true&"
import script from "./orderModeDeductionLists.vue?vue&type=script&lang=js&"
export * from "./orderModeDeductionLists.vue?vue&type=script&lang=js&"
import style0 from "./orderModeDeductionLists.vue?vue&type=style&index=0&id=0b538d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b538d82",
  null
  
)

export default component.exports